// src/chains/ethereum.js - Updated with SushiSwap API support
import { createChainConfig } from './chainConfig';

export const ethereumConfig = createChainConfig({
  key: 'ethereum', 
  chainId: 1,
  name: 'Ethereum Mainnet',
  rpcUrl: 'https://1rpc.io/eth',
  explorerUrl: 'https://etherscan.io',
  
  // Native token information
  nativeTokenSymbol: 'ETH',
  nativeTokenName: 'Ethereum',
  nativeTokenIcon: 'https://i.imgur.com/0ZOPyLn.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH for Ethereum
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'ethereum',
  geckoTerminalId: 'eth',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/ethereum.json',
  
  // Use SushiSwap API instead of KyberSwap API or direct contract calls
  aggregatorAddress: 'SushiSwap', // Special value indicating SushiSwap API usage
  sushiswapConfig: {
    // Base URL of the SushiSwap API
    apiBaseUrl: 'https://api.sushi.com',
    // SushiSwap router address - will be obtained from the API response
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' 
  },
  
  // Keep the old aggregator address for reference or fallback
  legacyAggregatorAddress: '0xC38324D5EB02072f3AdD7207CaD24Dea9dA1bE91',
  
  // Transaction support
  supportsEIP1559: true,
  
});